import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const competitionApi = createAsyncThunk(
  "auth/competitions",
  async (data, { rejectWithValue }) => {
    try {
      const paramsData = new URLSearchParams(data);
      const response = await AuthAxios.get(
        apiRoutes.competitionList, { params: data }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const competitionSlice = createSlice({
  name: "competition",
  initialState: {
    result: [],
    loading: false,
    error: null,
    message: "",
    total: 0,
  },
  extraReducers: (builder) => {
    builder.addCase(competitionApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(competitionApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results;
      state.message = action?.payload?.message;
      state.total = action?.payload?.count;
    });
    builder.addCase(competitionApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const competitionReducer = competitionSlice.reducer;
